if (!window.laClaireGamedaySelectsLoaded) {
  window.laClaireGamedaySelectsLoaded = true;
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-gameday-select]')) return;
    const next = new URL(select.dataset.productUrl, window.location.origin);
    next.search = window.location.search;
    next.searchParams.delete('option_values');
    next.searchParams.set('variant', select.value);
    if (next.href !== window.location.href) window.location.assign(next.href);
  });
}
